import React from 'react';
import { useIsMobile } from './hooks/use-mobile';
import HowItWorksDesktop from './HowItWorksDesktop';
import HowItWorksMobile from './HowItWorksMobile';

const HowItWorksWrapper = () => {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? <HowItWorksMobile /> : <HowItWorksDesktop />}
    </>
  );
};

export default HowItWorksWrapper;
